import { z } from "zod";

import {
  achPaymentSchema,
  authorizeNetCreditCardPaymentInputSchema,
  authorizeNetCustomerCreditCardPaymentSchema,
  cashPaymentSchema,
  celeroCreditCardPaymentInputSchema,
  checkPaymentSchema,
  createOrderSchema,
  existingCustomerSchema,
  newCustomerSchema,
  wirePaymentSchema,
} from "@gsa/db/schema";

export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  tags: string[];
  variants: Variant[];
}

export interface Variant {
  id: string;
  productId: string;
  name: string;
  price: number;
  image: string;
}

export interface CartItem {
  productId: string;
  quantity: number;
}

export interface Cart {
  id: string;
  userId: string | null;
  items: CartItem[];
}

export const createGuestOrderSchema = z.object({
  customer: z.discriminatedUnion("type", [
    existingCustomerSchema,
    newCustomerSchema,
  ]),

  // cardInput: creditCardInputSchema.nullable().optional(),

  payment: z.discriminatedUnion("type", [
    authorizeNetCreditCardPaymentInputSchema,
    authorizeNetCustomerCreditCardPaymentSchema,
    celeroCreditCardPaymentInputSchema,
    checkPaymentSchema,
    cashPaymentSchema,
    wirePaymentSchema,
    achPaymentSchema,
  ]),
});

export type CreateGuestOrderSchema = z.infer<typeof createGuestOrderSchema>;

export const createGuestOrderResolvedSchema = createOrderSchema
  .omit({
    source: true,
    salesRep: true,
    items: true,
  })
  .merge(
    z.object({
      recaptchaToken: z.string(),
    }),
  );

export type CreateGuestOrderResolvedSchema = z.infer<
  typeof createGuestOrderResolvedSchema
>;
